export default "__VITE_ASSET__CWx_97et__"